import template from "./managing-org-device-report.component.html";


function ManagingOrgDeviceReportCtrl(
  sweet,
  DateManipulationService,
  ReportingService,
  // SessionsService,
  ToastsService
) {
  "ngInject";

  let vm = this;

  // vm.initialize = () => {
  //   vm.managingOrgId = SessionsService.getCurrentDistributorKey();
  //   vm.isManagingOrgAdmin = SessionsService.isManagingOrgAdmin(vm.managingOrgId);
  // };

  vm.generateDisplayReport = () => {
      return ReportingService.deviceReportUrl({managingOrgId:vm.managingOrgId});
  };

  vm.generateManagingOrgDisplayReport = function () {
    let data = {
      'managingOrgId': vm.managingOrgId,
      'startDate': DateManipulationService.formatIsoDatetime(new Date()),
      'endDate': DateManipulationService.formatIsoDatetime(new Date())
    };
    return ReportingService.post(data)
      .then(() => {
        ToastsService.showSuccessToast('Device report queued. Please check the report list');
      }, () => {
        return sweet.show('Oops...', 'There was a problem queueing the report.', 'error');
      });
  };

  vm.$onChange = changes => {
    console.log(changes)
    // vm.managingOrgId = SessionsService.getCurrentDistributorKey();
    // vm.isManagingOrgAdmin = SessionsService.isManagingOrgAdmin(vm.managingOrgId);
  }
}

export const managingOrgDeviceReport = {
  template: template,
  bindings: {
    managingOrgId: '<',
    isManagingOrgAdmin: '<'
  },
  controller: ManagingOrgDeviceReportCtrl,
};

angular.module('skykitProvisioning').component('managingOrgDeviceReport', managingOrgDeviceReport);